import React, { useState } from 'react';
import { Truck, Package, ClipboardList, UserCog, Bot, BarChart3 } from 'lucide-react';
import VehiclesPage from './VehiclesPage';
import InventoryPage from './InventoryPage';
import WorkOrdersPage from './WorkOrdersPage';
import TechniciansPage from './TechniciansPage';
import ShopAssistantPage from './ShopAssistantPage';
import UnitCostSummaryPage from './UnitCostSummaryPage';

const TABS = [
  { key: 'vehicles', label: 'Vehicles', icon: Truck },
  { key: 'inventory', label: 'Parts Inventory', icon: Package },
  { key: 'work-orders', label: 'Work Orders', icon: ClipboardList },
  { key: 'technicians', label: 'Technicians', icon: UserCog },
  { key: 'unit-costs', label: 'Unit Costs', icon: BarChart3 },
  { key: 'assistant', label: 'Shop Assistant', icon: Bot },
];

export default function WrenchBoardPage() {
  const [tab, setTab] = useState('vehicles');

  return (
    <div data-testid="wrench-board-page" className="space-y-4">
      <div className="flex items-center gap-1 border-b border-border overflow-x-auto">
        {TABS.map(t => (
          <button
            key={t.key}
            data-testid={`tab-${t.key}`}
            onClick={() => setTab(t.key)}
            className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors -mb-px whitespace-nowrap ${
              tab === t.key
                ? 'border-primary text-primary'
                : 'border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground/30'
            }`}
          >
            <t.icon className="h-4 w-4" />
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'vehicles' && <VehiclesPage />}
      {tab === 'inventory' && <InventoryPage />}
      {tab === 'work-orders' && <WorkOrdersPage />}
      {tab === 'technicians' && <TechniciansPage />}
      {tab === 'unit-costs' && <UnitCostSummaryPage />}
      {tab === 'assistant' && <ShopAssistantPage />}
    </div>
  );
}
